import { PieChart, Pie, Cell, Tooltip } from "recharts";
import React, { useEffect, useState } from "react";
import { useLazyGetDashboardSearchQuery } from "../../../../services/Api";
import LoaderSpiner from "../../../../components/loaderSpiner";

const COLORS = ["#5D733C", "#F2D53F", "#EF476F", "#8338EC", "#3A86FF",];

export default function TravellerProfileChart() {
  const [trigger, { data, isLoading, error }] =
    useLazyGetDashboardSearchQuery();
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    trigger()
      .unwrap()
      .then((response) => {
        const genderStats =
          response?.data?.usersStats?.UsersStats?.[0]?.genderWise || [];
        const formattedData = genderStats.map((item) => ({
          name:
            item.gender.charAt(0).toUpperCase() +
            item.gender.slice(1).toLowerCase(),
          value: item.count,
        }));
        setChartData(formattedData);
      })
      .catch((err) => {
        // console.error(
        //   "Unable to fetch data. Please check your internet connection and try again.",
        //   err
        // );
      });


  }, [trigger]);

  if (isLoading) {
    return <LoaderSpiner />;
  }
  if (error) return <p>Error loading data. Please try again later.</p>;

  return (
    <div className="bg-lightgreen p-6 rounded-[1.75rem] h-full flex flex-col">
      <h3 className="text-lg font-roboto-mono text-[18px] font-bold self-start">
        Traveller Profile Chart
      </h3>

      {/* Centered Chart and Legend */}
      <div className="flex flex-col items-center flex-grow">
        {/* Chart Section */}
        <div className="relative flex justify-center items-center w-[250px] h-[250px]">
          <PieChart width={200} height={200}>
            <Pie
              data={chartData}
              innerRadius={60}
              outerRadius={80}
              paddingAngle={0}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                backgroundColor: "#F9FAFB",
                color: "#333",
                borderRadius: "8px",
                padding: "8px",
                fontSize: "14px",
              }}
              labelStyle={{
                fontWeight: "bold",
                fontSize: "14px",
              }}
              formatter={(value) => `${value}%`}
            />
          </PieChart>
          <div className="absolute flex flex-col justify-center items-center inset-0">
            {chartData.length > 0 && (
              <p className="text-2xl font-bold">{chartData[0].value}%</p>
            )}
          </div>
        </div>

        {/* Legend Section */}
        <div className="flex flex-wrap justify-center gap-4 mt-4">
          {chartData.map((entry, index) => (
            <div key={entry?.name} className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              ></div>
              <span className="text-sm">{entry?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
